module.exports = __webpack_public_path__ + "img/microwave.jpg.160ecf71.webp";